import { AnimatedHeading } from './AnimatedHeading'
import type { Locale } from '../content/site'

export type OfficeMapLocation = {
  name: Record<Locale, string>
  address: Record<Locale, string>
  mapsUrl: string
  embedUrl: string
}

const labels = {
  fa: {
    kicker: 'موقعیت دفتر',
    title: 'ما را روی نقشه پیدا کنید',
    note: 'برای هماهنگی ملاقات حضوری، پیش از مراجعه با ما در تماس باشید.',
    address: 'نشانی دفتر',
    directions: 'مشاهده و مسیریابی در نشان',
    mapPrompt: 'موقعیت دفتر پایه‌تک در نقشه نشان',
  },
  en: {
    kicker: 'Our office',
    title: 'Find us on the map',
    note: 'Please get in touch before visiting to arrange a meeting.',
    address: 'Office address',
    directions: 'View and get directions on Neshan',
    mapPrompt: 'Paye Tech office location on Neshan map',
  },
} as const

export function OfficeLocation({ locale, location, showAddress = true }: { locale: Locale; location: OfficeMapLocation; showAddress?: boolean }) {
  const t = labels[locale]

  return (
    <section id="location" className="office-location section-block" aria-labelledby="location-title">
      <div className="office-location__inner">
        <div className="office-location__details">
          <p className="section-kicker">{t.kicker}</p>
          <AnimatedHeading as="h2" id="location-title">{t.title}</AnimatedHeading>
          <p className="office-location__note">{t.note}</p>
          {showAddress && (
            <div className="office-location__address">
              <span>{t.address}</span>
              <strong>{location.name[locale]}</strong>
              <address>{location.address[locale]}</address>
            </div>
          )}
        </div>
        <div className="office-location__map">
          <iframe
            title={t.mapPrompt}
            className="office-location__map-iframe"
            src={location.embedUrl}
            width="600"
            height="450"
            loading="lazy"
            allowFullScreen
            tabIndex={-1}
            aria-hidden="true"
          />
          <a
            className="office-location__map-link"
            href={location.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t.directions}
            title={t.directions}
          />
        </div>
      </div>
    </section>
  )
}
